import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import FontKeys from '../FontKeys';
import gameData from '../gameData';
import UIAssetKeys from '../UIAssetKeys';

export default class Key extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     * @param {number} x 
     * @param {number} y 
     */
    constructor(scene, x, y, keyId, w, h)
    {
        super(scene, x, y);

        this.keyWidth = w;
        this.keyHeight = h;
        this.keyValue = keyId;
        if (this.keyValue.indexOf("shift") != -1) this.keyValue = "shift";
        if (this.keyValue == "shift" || this.keyValue == "enter" || this.keyValue == "delete")
        {
            this.keyWidth = w * 2;
        }
        else if (this.keyValue == "space")
        {
            this.keyWidth = w * 5;
        }
        this.keyId = keyId + "_key";
        this.keyBg = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._mobile_btn_keyboard, this).setOrigin(0);

        this.setInteractive({ hitArea: new Phaser.Geom.Rectangle(0, 0, this.keyWidth, this.keyHeight), hitAreaCallback: Phaser.Geom.Rectangle.Contains, useHandCursor: true });

        let keyStr = this.keyValue.toUpperCase();
        let fontSize = 36;
        this.keyText = ABCyaPhaser.Text.addText(this.keyWidth / 2, this.keyHeight / 2, fontSize, 0x333333, FontKeys._odin_roundedregular, keyStr, this).setOrigin(0.5);

        this.isDown = false;
    }

    showKeyPress(isDown)
    {
        this.isDown = isDown;

        this.keyBg.setTint(this.isDown ? gameData.KEY_DOWN_COLOR : gameData.KEY_UP_COLOR);
    }
}